<template>
  <el-form :model="uInfo" :rules="rules" ref="loginForm" label-position="top">
    <el-form-item :label="$t('message.home.orderEmail')" prop="username">
      <el-input v-model="uInfo.username" :placeholder="$t('message.home.pleaseEnterEmail')"
        @keyup.enter.native="vueLogin"></el-input>
    </el-form-item>
    <el-form-item :label="$t('message.home.password')" prop="password">
      <el-input v-model="uInfo.password" :type="showPassword ? 'password' : 'text'"
        :placeholder="$t('message.home.pleaseEnterPassword')" @keyup.enter.native="vueLogin">
        <template slot="suffix">
          <img class="password-icon" :src="showPassword ? imageMap.close : imageMap.open"
            @click="showPassword = !showPassword" />
        </template>
      </el-input>
    </el-form-item>
    <el-form-item prop="code" :label="$t('message.home.verificationCode')">
      <el-row :span="24">
        <el-col :span="16">
          <el-input size="small" v-model="uInfo.code" :maxlength="code.len"
            :placeholder="$t('message.home.pleaseEnterVerificationCode')" @keyup.enter.native="vueLogin"></el-input>
        </el-col>
        <el-col :span="8">
          <div class="login-code">
            <img :src="code.src" class="login-code-img" @click="refreshCode" />
          </div>
        </el-col>
      </el-row>
    </el-form-item>
    <div style="display: flex; justify-content: space-between; margin-top: 25px">
      <p class="tips">
        {{ $t("message.home.noAccount") }}
        <span @click="goRegister">{{ $t("message.home.signUp") }}</span>
      </p>
    </div>
    <el-form-item>
      <el-button class="sing-in-btn" type="primary" :loading="loading" @click="vueLogin">
        {{ $t("message.home.signIn") }}
      </el-button>
    </el-form-item>
    <EsOnlineServiceView v-model="showOnlieService" />
  </el-form>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import common from "@/util/common";
import { loginByUsername } from '@/api/login.js'
import { randomLenNum, encryption } from '@/util/util.js'
import { navigateAfterLogin } from '@/util/shopAuth'
import { securityKey } from '@/config/index.js'
import { BIZ_MESSAGE_LAST_ID } from "@/common";

export default {
  name: "EsEmailForm",
  data() {
    return {
      loading: false,
      showPassword: true,
      showOnlieService: false,
      imageMap: {
        open: require("@/assets/image/eye-open.png"),
        close: require("@/assets/image/eye-close.png"),
      },
      rules: {
        username: [
          common.ruleUtils.getRule("required", this.$t("message.home.pleaseEnterEmail")),
          common.ruleUtils.getRule("email"),
        ],
        password: [
          common.ruleUtils.getRule("required", this.$t("message.home.pleaseEnterPassword")),
          common.ruleUtils.getRule("password"),
        ],
      },
      code: { src: "/code", value: "", len: 4, type: "text" },
      uInfo: { username: "", password: "", code: "", randomStr: "" },
    };
  },
  mounted() { this.refreshCode(); },
  activated() { this.refreshCode(); },
  methods: {
    ...mapMutations({ setToken: "SETTOKEN", setHanders: "SETHANDERS" }),
    ...mapActions(["getUserInfo", "applyMemberLanguagePreference"]),
    refreshCode() {
      this.uInfo.code = ''
      this.uInfo.randomStr = randomLenNum(this.code.len, true)
      this.code.src = this.publicGlobalUrl + '/code?randomStr=' + this.uInfo.randomStr
    },
    vueLogin() {
      this.$refs.loginForm.validate(valid => {
        if (!valid) return;
        const user = encryption({ data: this.uInfo, key: securityKey, param: ['password'] });
        this.loading = true;
        loginByUsername(user.username, user.password, user.code, user.randomStr).then(async response => {
          if (response.data.user) {
            this.$store.commit("SETUSERINFO", response.data.user);
            this.setHanders({
              authorization: 'Bearer ' + response.data.access_token,
              userId: response.data.user.id,
              username: response.data.user.username
            });
            localStorage.setItem(BIZ_MESSAGE_LAST_ID, "");
            this.setToken(response.data.access_token);
            localStorage.setItem('BIZ_TOKEN', response.data.access_token);
            this.$refs.loginForm.resetFields();
            this.$message.success(this.$t('message.home.loginSuccess'));
            const langChanged = await this.applyMemberLanguagePreference();
            if (!langChanged) navigateAfterLogin(this);
          } else {
            this.refreshCode();
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
          this.refreshCode();
          this.$message.error(this.$t('message.home.loginFail') || 'Login failed');
        });
      });
    },
    goRegister() { this.$router.push("/register"); },
  },
};
</script>
